<script setup lang="ts">
import { AuthQuick } from "@/components/Auth";
import { type TAuthQuickColor } from "~/components/Auth/types";

const { t } = useI18n();

interface Props {
  color?: TAuthQuickColor;
}

const props = defineProps<Props>();
</script>
<template>
  <div>
    <div :class="$style.promo">
      <span>
        {{ t("banner.auth.promo_title") }}
      </span>
      <span>
        {{ t("banner.auth.promo_desc") }}<br />{{
          t("banner.auth.promo_desc_2")
        }}
      </span>
    </div>
    <AuthQuick
      size="small"
      :color="props.color"
      :class="$style.auth"
      google
      apple
      telegram
      whatsapp
    />
  </div>
</template>

<style lang="scss" module>
.promo {
  @apply p-5 bg-neutral-800 text-white flex flex-col gap-3 leading-[1.1] rounded-[16px] mb-4;

  & > span {
    &:first-child {
      @apply font-medium;
    }

    &:last-child {
      @apply text-[30px] font-light;
    }
  }
}

.auth {
  @apply pb-2;
}
</style>

